import React from 'react';
import { getStatusColor, getPriorityColor } from '../utils';

const TicketStatusChips = ({ ticket }) => {
  return (
    <div className="mb-6 flex gap-3 flex-wrap justify-center">
      <div className={`px-4 py-3 text-base font-poppins font-semibold rounded-xl flex items-center gap-2`}
           style={{
             backgroundColor: `${getStatusColor(ticket.status)}08`,
             color: getStatusColor(ticket.status),
             border: `2px solid ${getStatusColor(ticket.status)}30`,
             boxShadow: `0 4px 12px ${getStatusColor(ticket.status)}20`
           }}>
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
        </svg>
        Status: {ticket.status}
      </div>
      
      <div className={`px-4 py-3 text-base font-poppins font-semibold rounded-xl flex items-center gap-2`}
           style={{
             backgroundColor: `${getPriorityColor(ticket.priority)}08`,
             color: getPriorityColor(ticket.priority),
             border: `2px solid ${getPriorityColor(ticket.priority)}30`,
             boxShadow: `0 4px 12px ${getPriorityColor(ticket.priority)}20`
           }}>
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
        Priority: {ticket.priority}
      </div>
      
      <div className="px-4 py-3 text-base font-poppins font-semibold rounded-xl flex items-center gap-2 bg-blue-500/8 text-blue-600 border-2 border-blue-500/30 shadow-lg">
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
        </svg>
        Category: {ticket.category.replace(/_/g, ' ')}
      </div>
    </div>
  );
};

export default TicketStatusChips;